import {
  START_LOADING,
  END_LOADING,
  FETCH_ACCOUNTING_SETTINGS,
  UPDATE_ACCOUNTING_SETTINGS,
  ACCOUNTING_SETTINGS_ERROR,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  accountingSettings: {},
  error: null,
};

const accountingSettings = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true, error: null };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_ACCOUNTING_SETTINGS:
      return { ...state, accountingSettings: action.payload };
    case UPDATE_ACCOUNTING_SETTINGS:
      return { ...state, accountingSettings: action.payload };
    case ACCOUNTING_SETTINGS_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default accountingSettings;
